import React from 'react';
import classnames from 'classnames';
import classes from './checkbox-section.scss';
export let CheckboxInputType = /*#__PURE__*/function (CheckboxInputType) {
  CheckboxInputType[CheckboxInputType["CHECKBOX"] = 0] = "CHECKBOX";
  CheckboxInputType[CheckboxInputType["RADIOBUTTON"] = 1] = "RADIOBUTTON";
  return CheckboxInputType;
}({});
export const Checkbox = ({
  id,
  count,
  name,
  dataInput,
  isSelected,
  isDisabled,
  color,
  type,
  onClickCheckbox
}) => {
  const inputId = `${dataInput}_${name}`;
  return /*#__PURE__*/React.createElement("label", {
    key: inputId,
    className: classnames(classes.checkbox, {
      [classes.disabled]: isDisabled
    }),
    htmlFor: inputId,
    "data-input": name
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: inputId,
    checked: isSelected,
    onChange: () => onClickCheckbox(id)
  }), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.mark, {
      [classes.circle]: type === CheckboxInputType.RADIOBUTTON
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.innerMark, {
      [classes.innerCircle]: type === CheckboxInputType.RADIOBUTTON,
      [classes.innerSquare]: type === CheckboxInputType.CHECKBOX
    }),
    style: {
      backgroundColor: type === CheckboxInputType.RADIOBUTTON ? color : undefined
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.label, {
      [classes.capitalize]: name !== 'Swag.com'
    })
  }, /*#__PURE__*/React.createElement("span", {
    "data-text": "Name"
  }, name), count ? /*#__PURE__*/React.createElement("span", {
    className: classes.count,
    "data-text": "Count"
  }, "\xA0(", count, ")") : null));
};